import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as utils from "../../Utils/comman";
import DataTable from "react-data-table-component";
import CustomPagination from "../../Utils/CustomPagination";
import * as RB from "react-bootstrap";
import { Eye } from "iconsax-react";
import Select from "react-select";
import EmployeeGraphView from "./EmployeeGraphView";
import KeyPersonWiseView from "./KeyPersonWiseGraphView";

function MyTeamCounter({ tabKey }) {
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const [counterList, setCounterList] = useState([]);
  const [filters, setFilters] = useState({
    counterName: [],
    contact: "",
    city: "",
    state: "",
    empCode: "",
    district: "",
  });
  const [appliedFilters, setAppliedFilters] = useState({ ...filters });
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [counter, setCounter] = useState([]);
  const [showGraph, setShowGraph] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const userProfile = useSelector((state) => state.userProfile.userProfile);

  // new states for calculations
  const [myCounterCalc, setMyCounterCalc] = useState(null);
  const [teamCounterCalc, setTeamCounterCalc] = useState(null);

  useEffect(() => {
    getCounter();
  }, []);

  useEffect(() => {
    getCounterList();
  }, [page, appliedFilters, tabKey]);

  const vendorTypes = [
    "Dealer",
    "Distributor",
    "Retailer",
    "Key Accounts",
    "PRO",
  ];

  const getCounter = async () => {
    const userId = userProfile?.employeeId;
    let allData = [];

    for (const type of vendorTypes) {
      const formData = new FormData();
      formData.append("vendor_type", type);
      formData.append("id", "");
      formData.append("userId", userId);

      try {
        const res = await utils.callAPI(
          "post",
          `/sales/getsalesFormbyid`,
          formData
        );
        if (res && Array.isArray(res?.result)) {
          allData = [...allData, ...res.result];
        }
      } catch (err) {
        console.error(`Error fetching for ${type}:`, err);
      }
    }

    setCounter(allData);
  };

  const getCounterList = async () => {
    const { counterName, contact, empCode, city, state, district } =
      appliedFilters;

    const counterIds = Array.isArray(counterName)
      ? counterName.join(",")
      : counterName;

    const type = tabKey === "myCounter" ? "my_counter" : "team_counter";

    try {
      const res = await utils.callAPI(
        "get",
        `meeting/counter/other-list?page=${page}&per_page=${countPerPage}&type=${type}&counter_name=${counterIds}&key_person=${contact}&city=${city}&state=${state}&district=${district}&emp_code=${empCode}`
      );

      if (res) {
        if (tabKey === "teamCounter") {
          setTeamCounterCalc(res);

          // also fetch my_counter for combined card
          const myRes = await utils.callAPI(
            "get",
            `meeting/counter/other-list?page=${page}&per_page=${countPerPage}&type=my_counter`
          );
          setMyCounterCalc(myRes);

          if (Array.isArray(res?.list?.result)) {
            const unique = res.list.result.reduce((acc, curr) => {
              if (!acc.find((item) => item.employeeId === curr.employeeId)) {
                acc.push(curr);
              }
              return acc;
            }, []);
            setCounterList({ ...res, list: { ...res.list, result: unique } });
          } else {
            setCounterList(res);
          }
        } else {
          setMyCounterCalc(res);
          setCounterList(res);
        }
      } else {
        setCounterList([]);
      }
    } catch (err) {
      console.error(err);
      setCounterList([]);
    }
  };

  const columns =
    tabKey === "teamCounter"
      ? [
          { name: "Employee Name", selector: (row) => row.emp_name },
          { name: "Employee Id", selector: (row) => row.employeeId },
          {
            name: "Action",
            center: true,
            cell: (row) => (
              <RB.Button
                className="btn-flat ms-1"
                title="View"
                onClick={handleView(row)}
              >
                <Eye />
              </RB.Button>
            ),
          },
        ]
      : [
          {
            name: "Counter",
            selector: (row) => row.dealership_name,
            width: "220px",
          },
          { name: "State", selector: (row) => row.company_state },
          { name: "District", selector: (row) => row.company_district },
          { name: "City", selector: (row) => row.company_city },
          {
            name: "Action",
            center: true,
            cell: (row) => (
              <RB.Button
                className="btn-flat ms-1"
                title="View"
                onClick={handleView(row)}
              >
                <Eye />
              </RB.Button>
            ),
          },
        ];

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleView = useCallback((row) => async () => {
    setShowGraph(true);
    setCurrentRow(row);
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleFind = () => {
    setAppliedFilters(filters);
    setPage(1);
    setShowGraph(false);
  };

  const handleReset = () => {
    const resetFilters = {
      counterName: [],
      contact: "",
      city: "",
      state: "",
      empCode: "",
      district: "",
    };
    setFilters(resetFilters);
    setAppliedFilters(resetFilters);
    setPage(1);
    setShowGraph(false);
  };

  // helper for rendering calculation card
  const renderCalculation = (title, data) => {
    if (!data) return null;

    const totalAmt = parseFloat(data.total_amt || 0);
    const salesAmt = parseFloat(data.sales_amt || 0);
    const percent = salesAmt > 0 ? (totalAmt * 100) / salesAmt : 0;
    const formatted = percent.toFixed(2);
    const color = percent >= 3 ? "red" : "green";

    return (
      <RB.Card className="mt-3 p-3">
        <h5 className="fw-bold">{title}</h5>
        <h6>Total Sales = ₹{salesAmt.toLocaleString()}/-</h6>
        <h6>Total Marketing Expense = ₹{totalAmt.toLocaleString()}/-</h6>
        <h6 className="fw-bold" style={{ color }}>
          Budget Percentage = {formatted}%
        </h6>
      </RB.Card>
    );
  };

  return (
    <>
      <RB.Row className="mb-3">
        {tabKey === "myCounter" && (
          <RB.Col md={3}>
            <Select
              isMulti
              name="counterName"
              placeholder="Select Counter"
              value={counter
                .filter((c) => filters.counterName.includes(c.id))
                .map((c) => ({
                  value: c.id,
                  label: `${c.companyName} (${c.vendor_type})`,
                }))}
              onChange={(selected) => {
                const ids = selected.map((option) => option.value);
                setFilters({ ...filters, counterName: ids });
              }}
              options={counter.map((m) => ({
                value: m.id,
                label: `${m.companyName} (${m.vendor_type})`,
              }))}
            />
          </RB.Col>
        )}

        {tabKey === "teamCounter" && (
          <>
            <RB.Col md={3}>
              <RB.Form.Control
                type="text"
                placeholder="Employee Name"
                name="contact"
                value={filters.contact}
                onChange={handleFilterChange}
              />
            </RB.Col>
            <RB.Col md={3}>
              <RB.Form.Control
                type="text"
                placeholder="Employee Code"
                name="empCode"
                value={filters.empCode}
                onChange={handleFilterChange}
              />
            </RB.Col>
          </>
        )}

        {tabKey === "myCounter" && (
          <>
            <RB.Col md={2}>
              <RB.Form.Control
                type="text"
                placeholder="State"
                name="state"
                value={filters.state}
                onChange={handleFilterChange}
              />
            </RB.Col>
            <RB.Col md={2}>
              <RB.Form.Control
                type="text"
                placeholder="District"
                name="district"
                value={filters.district}
                onChange={handleFilterChange}
              />
            </RB.Col>
            <RB.Col md={2}>
              <RB.Form.Control
                type="text"
                placeholder="City"
                name="city"
                value={filters.city}
                onChange={handleFilterChange}
              />
            </RB.Col>
          </>
        )}

        <RB.Col md={3} className="mt-2">
          <RB.Button variant="primary" onClick={handleFind}>
            Find
          </RB.Button>
          <RB.Button variant="secondary" onClick={handleReset} className="ms-2">
            Reset
          </RB.Button>
        </RB.Col>
      </RB.Row>

      <DataTable
        columns={columns}
        data={counterList?.list?.result}
        highlightOnHover
        responsive
        pagination
        paginationServer
        paginationTotalRows={counterList?.list?.total}
        paginationPerPage={countPerPage}
        paginationComponentOptions={{
          noRowsPerPage: true,
        }}
        paginationComponent={() => (
          <CustomPagination
            currentPage={page}
            totalRows={counterList?.list?.total}
            rowsPerPage={countPerPage}
            onPageChange={handlePageChange}
          />
        )}
        striped
        onChangePage={(page) => setPage(page)}
        persistTableHead
        customStyles={{
          head: {
            style: {
              fontSize: "0.875rem",
              fontWeight: "bold",
            },
          },
        }}
      />

      {/* current calculation */}
      {renderCalculation(
        tabKey === "myCounter"
          ? "My Counter Calculation"
          : "Team Counter Calculation",
        counterList
      )}

      {/* combined calculation only for teamCounter */}
      {tabKey === "teamCounter" &&
        myCounterCalc &&
        teamCounterCalc &&
        (() => {
          const totalAmt =
            (parseFloat(myCounterCalc.total_amt || 0) || 0) +
            (parseFloat(teamCounterCalc.total_amt || 0) || 0);
          const salesAmt =
            (parseFloat(myCounterCalc.sales_amt || 0) || 0) +
            (parseFloat(teamCounterCalc.sales_amt || 0) || 0);

          const percent = salesAmt > 0 ? (totalAmt * 100) / salesAmt : 0; // ✅ ratio, not %
          const formatted = percent.toFixed(2); // 2 decimal places
          const color = percent >= 3 ? "red" : "green";

          return (
            <RB.Card className="mt-3 p-3 bg-light">
              <h5 className="fw-bold">Total (My + Team) Calculation</h5>
              <h6>Total Sales = ₹{salesAmt.toLocaleString()}/-</h6>
              <h6>Total Marketing Expense = ₹{totalAmt.toLocaleString()}/-</h6>
              <h6 className="fw-bold" style={{ color }}>
                Budget Ratio = {formatted} {/* ✅ updated label */}
              </h6>
            </RB.Card>
          );
        })()}

      {/* Graphs */}
      {showGraph &&
        (tabKey === "teamCounter" ? (
          <KeyPersonWiseView
            setShowGraph={setShowGraph}
            rowData={currentRow}
            tabKey={tabKey}
          />
        ) : (
          <EmployeeGraphView
            setShowGraph={setShowGraph}
            rowData={currentRow}
            tabKey={tabKey}
          />
        ))}
    </>
  );
}

export default MyTeamCounter;
